import React from 'react'
import { useTranslation } from 'react-i18next';
import { Box, Typography, Link, List, ListItem, Divider } from '@mui/material'
import { Helmet } from "react-helmet";
import MainLayout from '../../components/MainLayout'
import StaticPagesWrapper from '../../components/StaticPagesWrapper'
import ListItemHeader from '../../components/StaticPagesWrapper/ListItemHeader'

function Section({ title, children }) {
    const id = slugify(title);
    return (
        <Box component="section" id={id} sx={{ scrollMarginTop: 96 }}>
            <ListItemHeader>
                {title}
            </ListItemHeader>
            {children}
        </Box>
    );
}


function slugify(str) {
    return String(str)
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // quitar acentos
        .replace(/[^a-z0-9\s.-]/g, "")
        .trim()
        .replace(/\s+/g, "-");
}

const PrivacyPolicies = () => {

    const { i18n } = useTranslation();
    const lng = i18n.language || 'en';

    if (lng == 'es') {
        return (
            <MainLayout>
                <Helmet>
                    <title>Política de Privacidad, Aviso Legal y Política de Cookies - Trekzy</title>
                    <meta
                        name="description"
                        content="Política de Privacidad, Aviso Legal y Política de Cookies del sitio web de TREKZY"
                        data-react-helmet="true"
                    />
                </Helmet>

                <StaticPagesWrapper title="Trekzy">
                    <Box mb={8}>
                        {/* =====================
              POLÍTICA DE PRIVACIDAD
             ===================== */}
                        <ListItemHeader textAlign="center" styles={{ padding: 0, fontWeight: 'bold' }}>Política de Privacidad, Aviso Legal y Política de Cookies</ListItemHeader>

                        <ListItemHeader textAlign="center" styles={{ padding: 0, fontWeight: 'bold', paddingTop: 5 }}>POLÍTICA DE PRIVACIDAD</ListItemHeader>

                        <Section title="1.- ¿Quién es el responsable del tratamiento de sus datos?">
                            <Typography variant="body1" paragraph>
                                El responsable del tratamiento de sus datos personales es <strong>TOURS PRIVADOS, S.L.</strong>
                                {' '} (en adelante, <strong>“TREKZY”</strong>), con C.I.F <strong>B75873927</strong>, y domicilio social en
                                {' '}<strong>Pasaje de Bisbal 6, Planta 1, 28028, Madrid</strong>.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                La presente Política de Privacidad regula el acceso y el uso al <strong>Sito Web</strong> (en adelante,
                                el <strong>“Sitio Web”</strong>) que <strong>TREKZY</strong> pone a disposición de los usuarios de Internet (en adelante,
                                los <strong>“Usuarios”</strong>) interesados en los contenidos (en adelante, los <strong>“Contenidos”</strong>) y los
                                servicios (en adelante, los <strong>“Servicios”</strong>) ofertados por <strong>TREKZY</strong> en el mismo.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Correo electrónico de contacto:{' '}
                                <Link href="mailto:datospersonales@trekzy.com">datospersonales@trekzy.com</Link>
                            </Typography>
                        </Section>

                        <Section title="2.- Recomendaciones">
                            <Typography variant="body1" paragraph>
                                Por favor, lea atentamente y siga las siguientes recomendaciones:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Mantenga su equipo equipado con software antivirus debidamente actualizado contra software
                                    malicioso y aplicaciones de spyware que puedan poner en peligro su navegación por Internet y la
                                    información alojada en su equipo.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Lea y revise esta Política de Privacidad y todos los textos legales puestos a disposición por
                                    {' '}<strong>TREKZY</strong> en <strong>Sito Web</strong>.
                                </ListItem>
                            </List>
                        </Section>

                        <Section title="3.- Información sobre los datos que TREKZY recopila a través de Sito Web">
                            <Typography variant="body1" paragraph>
                                Para el correcto funcionamiento de <strong>Sito Web</strong>, <strong>TREKZY</strong> puede tener acceso a los siguientes
                                datos facilitados, en su caso, por parte de Usuario:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>(i) Datos de identificación: nombre, apellidos.</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (ii) Datos personales: fecha de nacimiento, género, dirección IP, dispositivo utilizado.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>(iii) Datos de contacto: email, teléfono.</ListItem>
                            </List>
                        </Section>

                        <Section title="4.- ¿Por qué TREKZY está legitimada para procesar sus datos?">
                            <Typography variant="body1" paragraph>
                                La base de legitimación de <strong>TREKZY</strong> para el tratamiento de los datos de los Usuarios a través
                                de esta Plataforma es la aplicación a petición de éste de medidas precontractuales.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                No obstante lo anterior, la base de legitimación para el envío de comunicaciones comerciales será
                                el consentimiento otorgado por el usuario.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> se toma muy en serio la protección de su privacidad y sus datos personales. Por esta
                                razón, sus datos personales se conservan de forma segura y se tratan con el máximo cuidado, de
                                conformidad con las disposiciones del Reglamento (UE) 2016/679 del Parlamento Europeo y del
                                Consejo, de 27 de abril de 2016, relativo a la protección de las personas físicas en lo que respecta
                                al tratamiento de datos personales y a la libre circulación de estos datos (el
                                {' '}<strong>“Reglamento general de protección de datos”</strong> o <strong>“RGPD”</strong>).
                            </Typography>

                            <Typography variant="body1" paragraph>
                                La presente Política de Privacidad regula el acceso y el uso del servicio que <strong>TREKZY</strong> pone a
                                disposición del Usuario interesado en los servicios y contenidos alojados en <strong>Sito Web</strong>.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Por lo que respecta a este punto, el Usuario podrá retirar su consentimiento en cualquier momento
                                mandando un mensaje a la siguiente dirección de correo electrónico:{' '}
                                <Link href="mailto:datospersonales@trekzy.com">datospersonales@trekzy.com</Link> sin que ello
                                afecte a la licitud del tratamiento basado en el consentimiento previo a su retirada.
                            </Typography>
                        </Section>

                        <Section title="5.- ¿Cuáles son las finalidades del tratamiento de sus datos personales?">
                            <Typography variant="body1" paragraph>
                                Sus datos de carácter personal recabados por <strong>TREKZY</strong> podrán ser utilizados para las siguientes
                                finalidades, según el consentimiento otorgado en el formulario de registro correspondiente:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>(i) Prestar los servicios ofertados a través de Sito Web.</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (ii) Gestionar, tramitar y dar respuesta a peticiones, solicitudes, incidencias o consultas del Usuario.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (iii) En caso de contar con el consentimiento del interesado, recibir por carta, teléfono, correo
                                    electrónico, SMS/MMS, o por otros medios de comunicación electrónica equivalentes,
                                    comunicaciones comerciales o información sobre productos y servicios de <strong>TREKZY</strong>.
                                </ListItem>
                            </List>
                        </Section>

                        <Section title="6.- Veracidad de los datos facilitados por los Usuarios">
                            <Typography variant="body1" paragraph>
                                El Usuario garantiza la veracidad de los datos personales facilitados y se compromete a comunicar a
                                <strong>TREKZY</strong> cualquier modificación de los mismos. El Usuario responderá, en cualquier caso, de la
                                veracidad de los datos facilitados, reservándose <strong>TREKZY</strong> el derecho a excluir de los servicios a
                                todo Usuario que haya facilitado datos falsos, sin perjuicio de las demás acciones que procedan en
                                Derecho.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Se recomienda que los Usuarios protejan sus datos con la máxima diligencia utilizando las
                                herramientas de seguridad adecuadas. <strong>TREKZY</strong> no será responsable de ningún robo, modificación
                                ilegal o pérdida de datos.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Cualquier modificación o actualización de los datos deberá ser comunicada a <strong>TREKZY</strong> a través de
                                los medios de comunicación previstos en la presente Política de Privacidad.
                            </Typography>
                        </Section>

                        <Section title="7.- Conservación de datos">
                            <Typography variant="body1" paragraph>
                                La protección de la privacidad y de los datos personales de los Usuarios es muy importante para
                                <strong>TREKZY</strong>. Por lo tanto, <strong>TREKZY</strong> hace todo lo posible para evitar que los datos del Usuario sean
                                utilizados de manera inadecuada. Sólo el personal autorizado tiene acceso a los datos del Usuario.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Los datos personales del Usuario se conservarán mientras permanezcan los mismos en la base de datos
                                de <strong>TREKZY</strong> para los fines del tratamiento para los que han sido facilitados, siempre que el Usuario
                                no haya revocado su consentimiento, solicitando la eliminación de su cuenta o el borrado de
                                determinados datos personales de <strong>Sito Web</strong>.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Posteriormente, en caso de ser necesario, <strong>TREKZY</strong> mantendrá la información bloqueada los plazos
                                legalmente establecidos.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> se compromete al cumplimiento de su obligación de secreto y confidencialidad de los
                                datos de carácter personal conforme a lo dispuesto en la legislación aplicable.
                            </Typography>
                        </Section>

                        <Section title="8.- Derechos de los usuarios">
                            <Typography variant="body1" paragraph>
                                Los usuarios tienen derecho a:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>(i) Acceder a sus datos personales;</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>(ii) Solicitar la rectificación de cualquier dato inexacto;</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>(iii) Solicitar la supresión de sus datos;</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>(iv) Solicitar que se limite el tratamiento de sus datos;</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>(v) Oponerse al tratamiento de sus datos;</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>(vi) Solicitar la portabilidad de sus datos.</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (vii) Asimismo, los Usuarios tendrán derecho a no ser objeto de decisiones basadas únicamente en el
                                    tratamiento automatizado de datos.
                                </ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                El Usuario puede ejercer todos estos derechos en la siguiente dirección de correo electrónico:{' '}
                                <Link href="mailto:datospersonales@trekzy.com">datospersonales@trekzy.com</Link> indicando el
                                motivo de su petición.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                El Usuario puede también enviar su petición por correo ordinario a la siguiente dirección:{' '}
                                <strong>Pasaje de Bisbal 6, Planta 1, 28028, Madrid</strong>.
                            </Typography>
                        </Section>

                        <Section title="Reclamaciones e información requerida en comunicaciones">
                            <Typography variant="body1" paragraph>
                                La comunicación dirigida a <strong>TREKZY</strong> deberá contener la siguiente información:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>Nombre y apellidos del Usuario;</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Petición en que se concreta la solicitud.</ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                Sin perjuicio de cualquier otro recurso administrativo o acción judicial, el Usuario tendrá derecho a
                                presentar una reclamación ante una Autoridad de Control, en particular en el Estado miembro en el
                                que tenga su residencia habitual, lugar de trabajo o lugar de la supuesta infracción, en caso de que
                                considere que el tratamiento de sus datos personales no es adecuado a la normativa, así como en el
                                caso de no ver satisfecho el ejercicio de sus derechos. La autoridad de control ante la que se haya
                                presentado la reclamación informará al reclamante sobre el curso y el resultado de la reclamación.
                            </Typography>
                        </Section>

                        <Section title="9.- Seguridad de datos">
                            <Typography variant="body1" paragraph>
                                La protección de la privacidad y de los datos personales de los Usuarios es muy importante para
                                <strong>TREKZY</strong>. Por ello, <strong>TREKZY</strong> ha tomado todas las medidas a su alcance para evitar que sus datos
                                sean utilizados de forma indebida, permitiendo el acceso a los mismos únicamente al personal
                                autorizado.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> mantiene la seguridad adecuada para la protección de los datos personales de acuerdo
                                con la legislación aplicable y ha establecido todos los medios técnicos a su alcance para evitar la
                                pérdida, mal uso, alteración, acceso no autorizado y robo de los datos facilitados por el Usuario a
                                través de <strong>Sito Web</strong>, sin perjuicio de informarle de que las medidas de seguridad en Internet no son
                                inexpugnables.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> se compromete a cumplir con el deber de secreto y confidencialidad respecto a los datos
                                de carácter personal de acuerdo con la legislación aplicable.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> no será responsable de los daños y perjuicios que pudieran derivarse del incumplimiento
                                de esta obligación por parte del Usuario.
                            </Typography>
                        </Section>

                        <Section title="10.- Transferencias y/o cesiones a terceros">
                            <Typography variant="body1" paragraph>
                                Se informa al Usuario de que sus datos de carácter personal no podrán ser cedidos a terceras
                                empresas o entidades nacionales. Los datos de los Usuarios únicamente podrán ser utilizados por
                                <strong>TREKZY</strong> para cualquier uso que sirva para cumplir correctamente con las finalidades del tratamiento
                                de datos de carácter personal recogidas en el punto 5 de esta Política de Privacidad.
                            </Typography>
                        </Section>

                        <Section title="11.- Preguntas">
                            <Typography variant="body1" paragraph>
                                Si tiene alguna duda sobre nuestra Política de Privacidad, póngase en contacto con nosotros enviando
                                un correo electrónico a{' '}
                                <Link href="mailto:datospersonales@trekzy.com">datospersonales@trekzy.com</Link>.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Asimismo, si considera que sus derechos no están debidamente salvaguardados, tiene derecho a
                                presentar una reclamación ante la <strong>Agencia Española de Protección de Datos</strong>, cuyos datos de
                                contacto son: teléfonos <strong>900 293 183</strong>; dirección postal <strong>C/Jorge Juan 6, 28001 Madrid</strong>; oficina
                                electrónica{' '}
                                <Link href="https://sedeagpd.gob.es/sede-electronica-web/" target="_blank" rel="noopener">
                                    https://sedeagpd.gob.es/sede-electronica-web/
                                </Link>
                                {' '}y Solicitud{' '}
                                <Link href="https://www.aepd.es" target="_blank" rel="noopener">
                                    www.aepd.es
                                </Link>
                                .
                            </Typography>
                        </Section>

                        <Section title="12.- Aceptación y Consentimiento">
                            <Typography variant="body1" paragraph>
                                El Usuario declara haber sido informado de las condiciones sobre protección de datos personales,
                                aceptando y consintiendo el tratamiento de los mismos por parte de <strong>TREKZY</strong>, en la forma y para
                                las finalidades indicadas en la presente Política de Privacidad.
                            </Typography>
                        </Section>

                        <Divider sx={{ my: 4 }} />

                        {/* =====================
              AVISO LEGAL
             ===================== */}
                        <ListItemHeader textAlign="center" styles={{ padding: 0, fontWeight: 'bold', paddingTop: 5 }}>AVISO LEGAL</ListItemHeader>

                        <Section title="1.- Derecho de la información">
                            <Typography variant="body1" paragraph>
                                Le informamos que este sitio Web{' '}
                                <Link href="https://www.trekzy.com" target="_blank" rel="noopener">
                                    www.trekzy.com
                                </Link>
                                {' '} (en adelante, el <strong>“Sitio Web”</strong>) es titularidad de <strong>Tours Privados, S.L.</strong> (en adelante,
                                {' '}<strong>“TREKZY”</strong>), con C.I.F. <strong>B75873927</strong>, y domicilio social en{' '}
                                <strong>Pasaje de Bisbal 6, Planta 1, 28028, Madrid</strong>, inscrita en el Registro Mercantil de Madrid,
                                Sección 8ª, Inscripción 1ª, Hoja <strong>M 845479</strong>.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                El acceso y/o uso de <strong>Sito Web</strong> le atribuye la condición de usuario.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                El usuario (en adelante, el <strong>“Usuario”</strong>) puede ponerse en contacto con <strong>TREKZY</strong> a través de la
                                dirección de correo electrónico{' '}
                                <Link href="mailto:datospersonales@trekzy.com">datospersonales@trekzy.com</Link>, así como
                                mediante el teléfono <strong>(+34) 917 578 557</strong>.
                            </Typography>
                        </Section>

                        <Section title="2.- Uso de Sito Web">
                            <Typography variant="body1" paragraph>
                                El Usuario asume la responsabilidad del uso de <strong>Sito Web</strong>. <strong>Sito Web</strong> puede proporcionar
                                acceso a multitud de textos, gráficos, dibujos, diseños, fotografías, contenidos multimedia, e
                                informaciones (en adelante, <strong>“Contenidos”</strong>) pertenecientes a <strong>TREKZY</strong> o a terceros a los que el
                                Usuario puede tener acceso.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                El Usuario deberá hacer un uso adecuado de los Contenidos y servicios ofrecidos a través de
                                <strong>Sito Web</strong> y con carácter enunciativo, pero no limitativo, a no emplearlos para:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (i) Incurrir en actividades ilícitas, ilegales o contrarias a la buena fe y al orden público.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (ii) Provocar daños en los sistemas físicos y lógicos de <strong>Sito Web</strong> de <strong>TREKZY</strong>, de sus
                                    proveedores o de terceras personas.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (iii) Introducir o difundir en la red virus informáticos o cualquier otro sistema físico o lógico
                                    susceptible de provocar los daños mencionados.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (iv) Intentar acceder, utilizar y/o manipular los datos de <strong>TREKZY</strong>, de terceros entes
                                    colaboradores y otros usuarios.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (v) Reproducir o copiar, distribuir, permitir el acceso del público a través de cualquier modalidad
                                    de comunicación pública, transformar o modificar los Contenidos, a menos que se cuente con la
                                    autorización de <strong>TREKZY</strong>.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (vi) Suprimir, ocultar o manipular los Contenidos sujetos a derechos de propiedad intelectual o
                                    industrial y demás datos identificativos de dichos derechos de <strong>TREKZY</strong> o de terceros
                                    incorporados a los Contenidos, así como los dispositivos técnicos de protección o cualesquiera
                                    mecanismos de información que puedan insertarse en los Contenidos.
                                </ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> tendrá derecho a investigar y denunciar cualquiera de las conductas mencionadas de
                                acuerdo con la Ley, así como a colaborar con las autoridades en la investigación de dichas
                                actuaciones.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> podrá suspender temporalmente y sin previo aviso, la accesibilidad a <strong>Sito Web</strong> con
                                motivo de operaciones de mantenimiento, reparación, actualización o mejora. No obstante, siempre
                                que las circunstancias lo permitan, <strong>TREKZY</strong> comunicará al Usuario, con antelación suficiente, la
                                fecha prevista para la suspensión de los servicios. <strong>TREKZY</strong> no se responsabiliza del uso que los
                                Usuarios puedan hacer de los Contenidos incluidos en <strong>Sito Web</strong>.
                            </Typography>
                        </Section>

                        <Section title="3.- Propiedad Intelectual e Industrial">
                            <Typography variant="body1" paragraph>
                                Todos y cada uno de los derechos de propiedad intelectual sobre el contenido y el diseño gráfico de
                                esta Plataforma (a título enunciativo, imágenes, sonido, audio, vídeo, software o textos; marcas o
                                logotipos, combinaciones de colores, estructura y diseño, selección de materiales usados, programas
                                de ordenador necesarios para su funcionamiento, acceso y uso, etc.) son propiedad exclusiva de
                                <strong>TREKZY</strong> o de un tercero que haya autorizado su uso. Por tanto, <strong>TREKZY</strong> tiene el derecho
                                exclusivo de explotación de dichos contenidos y diseño gráfico.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Por ello, en virtud de lo dispuesto en el Real Decreto Legislativo 1/1996, de 12 de abril, por el que
                                se aprueba el Texto Refundido de la Ley de Propiedad Intelectual, y en la Ley 17/2001, de 7 de
                                diciembre, de Marcas, así como cualquier otra legislación complementaria en materia de propiedad
                                intelectual e industrial, queda prohibida la reproducción, transmisión, adaptación, traducción,
                                distribución o comunicación pública, incluida la puesta a disposición o cualquier otra forma de
                                explotación comercial y/o modificación de todo o parte del contenido de <strong>Sito Web</strong>, salvo
                                autorización previa y expresa de <strong>TREKZY</strong>.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> no concede ninguna licencia o autorización para utilizar ninguno de sus derechos de
                                propiedad intelectual e industrial o cualquier otra propiedad o derecho relacionado con <strong>Sito Web</strong>
                                y/o los servicios o contenidos del mismo.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                El Usuario se compromete a respetar los derechos de Propiedad Intelectual e Industrial titularidad
                                de <strong>TREKZY</strong>. Se permite, en este sentido, la reproducción y almacenamiento temporal de los
                                contenidos de <strong>Sito Web</strong> en tanto ello sea estrictamente necesario para el uso y visualización de
                                <strong>Sito Web</strong> desde un ordenador/Tablet o teléfono personal.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                La legitimidad de los derechos de propiedad intelectual o industrial sobre los contenidos aportados
                                por los Usuarios es de la exclusiva responsabilidad de los mismos, que responderán frente a
                                cualquier reclamación de terceros derivada del uso ilícito de los contenidos de <strong>Sito Web</strong>.
                            </Typography>
                        </Section>

                        <Section title="4.- Protección de datos">
                            <Typography variant="body1" paragraph>
                                El uso de esta Plataforma puede requerir que los Usuarios proporcionen datos personales. <strong>TREKZY</strong>
                                trata este tipo de información de acuerdo con la legislación aplicable, y la recoge en su Política de
                                Privacidad.
                            </Typography>
                        </Section>

                        <Section title="5.- Responsabilidad y Garantías">
                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> declara que ha adoptado todas las medidas necesarias, dentro de sus posibilidades y
                                teniendo en cuenta el estado actual de la tecnología, para permitir el correcto funcionamiento y la
                                ausencia de virus y componentes dañinos en su Plataforma.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Sin embargo, <strong>TREKZY</strong> no puede ser considerada responsable por:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (i) la veracidad, integridad o actualización de los datos facilitados por los Usuarios;
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (ii) la interrupción del funcionamiento de <strong>Sito Web</strong> o fallos informáticos, averías telefónicas,
                                    desconexiones, retrasos o bloqueos causados por deficiencias o sobrecargas en las líneas
                                    telefónicas, centros de datos, en el sistema de Internet o en otros sistemas electrónicos,
                                    producidos en el curso de su funcionamiento;
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (iii) cualquier daño causado por terceros que infrinjan o vulneres los sistemas de seguridad de
                                    <strong>TREKZY</strong>.
                                </ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> no se responsabiliza del uso que los Usuarios puedan hacer de los Contenidos incluidos
                                en <strong>Sito Web</strong>.
                            </Typography>
                        </Section>

                        <Section title="6.- Duración y modificación">
                            <Typography variant="body1" paragraph>
                                El presente Aviso Legal estará vigente con carácter indefinido, pudiendo <strong>TREKZY</strong> efectuar cambios
                                sobre las condiciones especificadas en el mismo, y que entrarán en vigor desde el momento de su
                                publicación.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> podrá suprimir, añadir o cambiar tanto los Contenidos como los servicios que presta, así
                                como también la forma en la que los mismos aparezcan localizados o presentados. Se entienden como
                                vigentes, las condiciones que estén publicadas en el momento en el que el Usuario acceda a
                                <strong>Sito Web</strong> de <strong>TREKZY</strong>.
                            </Typography>
                        </Section>

                        <Section title="7.- Hipervínculos">
                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> informa al usuario de que, a su conocimiento los hipervínculos insertados en
                                <strong>Sito Web</strong> no son dañinos y su contenido es correcto. Sin embargo, en la medida en que el control
                                de estos hipervínculos no depende de <strong>TREKZY</strong>, ésta no puede asumir ningún tipo de
                                responsabilidad sobre las consecuencias que tenga el acceso a enlaces a otras aplicaciones o sitios
                                web.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                En este sentido, <strong>TREKZY</strong> no se hace responsable de la información contenida en estos enlaces de
                                terceros ni de cualesquiera efectos que pudieran derivarse de dicha información.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                La inclusión de vínculos con otros sitios web o aplicaciones no implica la aprobación de sus
                                contenidos por parte de <strong>TREKZY</strong> ni la existencia de ningún tipo de asociación entre <strong>TREKZY</strong> y sus
                                titulares.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                En consecuencia, el Usuario accede bajo su exclusiva responsabilidad al Contenido y en las
                                condiciones de uso que rijan en los mismos.
                            </Typography>
                        </Section>

                        <Section title="8.- Salvaguardia e interpretación">
                            <Typography variant="body1" paragraph>
                                Este Aviso Legal constituye un acuerdo entre cada uno de los Usuarios y <strong>TREKZY</strong>.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Si la autoridad competente declara que una disposición es ilegal, inválida o inaplicable, dicha
                                declaración con respecto a una o varias cláusulas se entenderá sin perjuicio de la validez de las demás
                                cláusulas.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                El hecho de que <strong>TREKZY</strong> no exija el cumplimiento estricto de ninguna de las disposiciones del
                                presente Aviso Legal no constituye ni puede interpretarse en modo alguno como una renuncia de su
                                parte a exigir el cumplimiento estricto en el futuro.
                            </Typography>
                        </Section>

                        <Section title="9.- Información General">
                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> perseguirá el incumplimiento del presente Aviso Legal, así como cualquier utilización
                                indebida de su portal, ejerciendo todas las acciones civiles y penales que le puedan corresponder en
                                derecho.
                            </Typography>
                        </Section>

                        <Section title="10.- Notificaciones">
                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> podrá realizar las oportunas comunicaciones a través de la dirección de correo electrónico
                                facilitada por los Usuarios en los formularios de registro o a través de cualquier otro medio
                                facilitado en los datos de contacto del Usuario.
                            </Typography>
                        </Section>

                        <Divider sx={{ my: 4 }} />

                        {/* =====================
              POLÍTICA DE COOKIES
             ===================== */}
                        <ListItemHeader textAlign="center" styles={{ padding: 0, fontWeight: 'bold', paddingTop: 5 }}>POLÍTICA DE COOKIES</ListItemHeader>

                        <Typography variant="body1" paragraph>
                            <strong>TOURS PRIVADOS, S.L.</strong> (en adelante, <strong>“TREKZY”</strong>) informa, a través de la presente Política de
                            Cookies, acerca de la utilización de dispositivos de almacenamiento y recuperación de datos en equipos
                            terminales de los Usuarios.
                        </Typography>

                        <Section title="1.- ¿Qué son las cookies?">
                            <Typography variant="body1" paragraph>
                                Esta Plataforma utiliza cookies y/o tecnologías similares que almacenan y recuperan información
                                cuando navegas. En general, estas tecnologías pueden servir para finalidades muy diversas, como, por
                                ejemplo, reconocerte como usuario, obtener información sobre tus hábitos de navegación, o
                                personalizar la forma en que se muestra el contenido. Los usos concretos que hacemos de estas
                                tecnologías se describen en el apartado “¿Para qué utiliza TREKZY las cookies?”.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                La información recogida por las cookies es anónima y no contiene ninguna información sensible, ya
                                que no recogen datos que puedan identificar personalmente al Usuario. En cualquier caso, el Usuario
                                podrá acceder a la configuración de su navegador para modificar y/o bloquear la instalación de las
                                Cookies enviadas desde <strong>Sito Web</strong>, sin que ello impida al acceso a los contenidos tal y como se
                                describe en los apartados “¿Cómo deshabilitar las cookies?” y “Cookies en los dispositivos móviles”
                                de la presente Política de Cookies.
                            </Typography>
                        </Section>

                        <Section title="2.- ¿Para qué utiliza TREKZY las cookies?">
                            <Typography variant="body1" paragraph>
                                De conformidad con el artículo 22 de la Ley de Servicios de la Sociedad de la Información y Comercio
                                Electrónico, así como en el Considerando (30) del Reglamento General de Protección de Datos (en
                                adelante, <strong>“RGPD”</strong>), la presente Plataforma utiliza cookies u otros dispositivos de almacenamiento y
                                recuperación de información para realizar un seguimiento de las interacciones de los Usuarios con los
                                servicios ofrecidos en <strong>Sito Web</strong>.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Las cookies permiten reconocer el navegador de un Usuario, así como el tipo de dispositivo desde el
                                que se accede a <strong>Sito Web</strong>, y se utilizan para facilitar la próxima visita del Usuario y hacer que
                                <strong>Sito Web</strong> resulte más útil.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> utiliza las cookies para:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (i) Optimizar la navegación del Usuario mediante el seguimiento de la sesión.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (ii) Recopilar información para optimizar la navegación y mejorar <strong>Sito Web</strong>.
                                </ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                <strong>Sito Web</strong> utiliza los siguientes tipos de cookies:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    <strong>Obligatorias o técnicas:</strong> Son aquellas estrictamente necesarias para prestar un servicio o
                                    contenido solicitado por el usuario. Éstas se encargan de aspectos técnicos como identificar
                                    registros y gestionar preferencias de herramientas en el uso, interacción y localización del acceso a
                                    los contenidos.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    <strong>De preferencias o personalización:</strong> Son aquellas que permiten recordar información para que el
                                    usuario acceda al servicio con determinadas características que pueden diferenciar su experiencia de
                                    la de otro usuario como, por ejemplo, el idioma o la configuración de la página en función del
                                    navegador utilizado.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    <strong>Estadísticas/analíticas:</strong> Son aquellas que, tratadas por nosotros o por terceros, nos permiten
                                    cuantificar el número de usuarios y así realizar la medición análisis estadístico de la utilización
                                    que hacen los usuarios del servicio ofertado. Para ello se analiza su navegación en <strong>Sito Web</strong> para
                                    mejorar la oferta de productos o servicios que ofrecemos.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    <strong>Publicitarias:</strong> Son aquellas que, tratadas por nosotros o por terceros, nos permiten analizar sus
                                    hábitos de navegación en Internet para que podamos mostrarle publicidad relacionada con su perfil
                                    de navegación.
                                </ListItem>
                            </List>
                        </Section>

                        <Section title="4.- ¿Cómo deshabilitar las cookies?">
                            <Typography variant="body1" paragraph>
                                Aquellas cookies que no sean obligatorias para la navegación de la presente Plataforma podrán
                                deshabilitarse.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Estos ajustes se encuentran en el pie de página de <strong>Sito Web</strong>. Además, todos los navegadores
                                permiten hacer cambios para desactivar la configuración de las cookies.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Este es el motivo por el que la mayoría de los navegadores ofrecen la posibilidad de administrar las
                                cookies, para obtener un control más preciso sobre la privacidad.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Estos ajustes se encuentran ubicados en las “opciones” o “preferencias” del menú de su navegador.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                A continuación, podrá encontrar los links de cada navegador para deshabilitar las cookies siguiendo
                                las instrucciones:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    <strong>Internet Explorer</strong> ({' '}
                                    <Link href="https://goo.gl/iU2wh2" target="_blank" rel="noopener">
                                        https://goo.gl/iU2wh2
                                    </Link>
                                    )
                                    <List sx={{ listStyle: 'circle', pl: 4, mt: 1 }}>
                                        <ListItem sx={{ display: 'list-item' }}>
                                            En el menú de herramientas, selecciones “Opciones de Internet”.
                                        </ListItem>
                                        <ListItem sx={{ display: 'list-item' }}>Haga clic en la pestaña de privacidad.</ListItem>
                                        <ListItem sx={{ display: 'list-item' }}>
                                            Podrá eliminar las cookies si selecciona la opción “eliminar el historial de exploración” y,
                                            posteriormente, en el apartado “cookies y permisos del sitio” accede al subapartado “ver cookies
                                            y datos del sitio” y selecciona la opción “Eliminar todo”.
                                        </ListItem>
                                        <ListItem sx={{ display: 'list-item' }}>
                                            Asimismo, la pestaña “cookies y permisos del sitio” permite configurar las opciones de privacidad
                                            preferidas por el usuario.
                                        </ListItem>
                                    </List>
                                </ListItem>

                                <ListItem sx={{ display: 'list-item' }}>
                                    <strong>Mozilla Firefox</strong> ({' '}
                                    <Link href="http://goo.gl/QXWYmv" target="_blank" rel="noopener">
                                        http://goo.gl/QXWYmv
                                    </Link>
                                    )
                                    <List sx={{ listStyle: 'circle', pl: 4, mt: 1 }}>
                                        <ListItem sx={{ display: 'list-item' }}>
                                            En la parte superior de la venta de Firefox hacer clic en el menú Ajustes.
                                        </ListItem>
                                        <ListItem sx={{ display: 'list-item' }}>Seleccionar Privacidad &amp; Seguridad.</ListItem>
                                        <ListItem sx={{ display: 'list-item' }}>
                                            Seleccionando la Opción “Personalizado” podrá seleccionar las Cookies que desea bloquear junto
                                            con otras cuestiones relacionadas con su privacidad.
                                        </ListItem>
                                    </List>
                                </ListItem>

                                <ListItem sx={{ display: 'list-item' }}>
                                    <strong>Google Chrome</strong> ({' '}
                                    <Link href="http://goo.gl/fQnkSB" target="_blank" rel="noopener">
                                        http://goo.gl/fQnkSB
                                    </Link>
                                    )
                                    <List sx={{ listStyle: 'circle', pl: 4, mt: 1 }}>
                                        <ListItem sx={{ display: 'list-item' }}>
                                            Hacer clic en el menú situado en la barra de herramientas.
                                        </ListItem>
                                        <ListItem sx={{ display: 'list-item' }}>Seleccionar Configuración.</ListItem>
                                        <ListItem sx={{ display: 'list-item' }}>
                                            En la selección “Privacidad y Seguridad” hacer clic en el botón “Cookies y datos de otros
                                            sitios”.
                                        </ListItem>
                                        <ListItem sx={{ display: 'list-item' }}>
                                            Podrá seleccionar la configuración general de las cookies, así como otros aspectos de privacidad.
                                        </ListItem>
                                    </List>
                                </ListItem>

                                <ListItem sx={{ display: 'list-item' }}>
                                    <strong>Safari</strong> ({' '}
                                    <Link href="https://goo.gl/dQywEo" target="_blank" rel="noopener">
                                        https://goo.gl/dQywEo
                                    </Link>
                                    )
                                    <List sx={{ listStyle: 'circle', pl: 4, mt: 1 }}>
                                        <ListItem sx={{ display: 'list-item' }}>
                                            En la app safari del Mac seleccione la opción de “Preferencias”.
                                        </ListItem>
                                        <ListItem sx={{ display: 'list-item' }}>Abra la pestaña de privacidad.</ListItem>
                                        <ListItem sx={{ display: 'list-item' }}>
                                            Seleccione la opción que quiera de la sección de “bloquear cookies”.
                                        </ListItem>
                                        <ListItem sx={{ display: 'list-item' }}>
                                            Recuerde que ciertas funciones y la plena funcionalidad de <strong>Sito Web</strong> pueden no estar
                                            disponibles después de deshabilitar las cookies.
                                        </ListItem>
                                    </List>
                                </ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                Si no desea ser rastreado por las cookies, Google ha desarrollado un complemento para instalar en su
                                navegador al que puede acceder en el siguiente enlace:{' '}
                                <Link href="http://goo.gl/up4ND" target="_blank" rel="noopener">
                                    http://goo.gl/up4ND
                                </Link>
                                .
                            </Typography>
                        </Section>

                        <Section title="5.- Cookies en los dispositivos móviles">
                            <Typography variant="body1" paragraph>
                                <strong>Sito Web</strong> de <strong>TREKZY</strong> también usa cookies u otros dispositivos de almacenamiento en
                                dispositivos móviles.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Aquellas cookies que no sean obligatorias para la navegación de la presente Plataforma podrán
                                deshabilitarse.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Estos ajustes se encuentran en el pie de página de <strong>Sito Web</strong>. Además, al igual que sucede en los
                                navegadores de ordenadores, lo navegadores de los dispositivos móviles permiten realizar cambios en
                                las opciones o ajustes de privacidad para desactivar o eliminar las cookies.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Si desea modificar las opciones de privacidad siga las instrucciones especificadas por el
                                desarrollador de su navegador para dispositivo móvil.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                A continuación, podrá encontrar algunos ejemplos de los links que le guiarán para modificar las
                                opciones de privacidad en su dispositivo móvil:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    <strong>IOS</strong>: ({' '}
                                    <Link href="http://goo.gl/61xevS" target="_blank" rel="noopener">
                                        http://goo.gl/61xevS
                                    </Link>
                                    )
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    <strong>Windows Phone</strong>: ({' '}
                                    <Link href="https://goo.gl/tKyb0y" target="_blank" rel="noopener">
                                        https://goo.gl/tKyb0y
                                    </Link>
                                    )
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    <strong>Chrome Mobile</strong>: ({' '}
                                    <Link href="http://goo.gl/XJp7N" target="_blank" rel="noopener">
                                        http://goo.gl/XJp7N
                                    </Link>
                                    )
                                </ListItem>
                            </List>
                        </Section>

                        <Section title="6.- Aceptación de cookies">
                            <Typography variant="body1" paragraph>
                                La presente Plataforma no instala nuestras cookies en los dispositivos de los usuarios hasta que estos
                                hayan aceptado la instalación de éstas.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Le informamos que en el caso de no aceptar la instalación de cookies o de deshabilitar alguna de
                                estas en la configuración, es posible que ciertos servicios no estén disponibles sin la utilización de
                                estas o que no pueda acceder a determinados servicios ni tampoco aprovechar por completo todo lo
                                que esta Plataforma le ofrece.
                            </Typography>
                        </Section>

                        <Divider sx={{ my: 4 }} />

                        {/* Footer */}
                        <Typography variant="body2" color="text.secondary" paragraph>
                            <Link href="https://www.trekzy.com" target="_blank" rel="noopener">
                                www.trekzy.com
                            </Link>
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Pasaje de Bisbal 6, Planta 1, 28028, Madrid (España)
                        </Typography>
                    </Box>
                </StaticPagesWrapper>
            </MainLayout>
        );
    } else {
        return (
            <MainLayout>
                <Helmet>
                    <title>Privacy Policy, Legal Notice and Cookies Policy - Trekzy</title>
                    <meta
                        name="description"
                        content="Privacy Policy, Legal Notice and Cookie Policy for TREKZY website"
                        data-react-helmet="true"
                    />
                </Helmet>

                <StaticPagesWrapper title="Trekzy">
                    <Box mb={8}>
                        {/* =====================
              PRIVACY POLICY
             ===================== */}
                        <ListItemHeader textAlign="center" styles={{ padding: 0, fontWeight: 'bold' }}>Privacy Policy, Legal Notice and Cookies Policy</ListItemHeader>

                        <ListItemHeader textAlign="center" styles={{ padding: 0, fontWeight: 'bold', paddingTop: 5 }}>PRIVACY POLICY</ListItemHeader>

                        <Section title="1.- Who is the data controller of your personal data?">
                            <Typography variant="body1" paragraph>
                                TOURS PRIVADOS, S.L. (hereinafter, <strong>“TREKZY”</strong>), with Tax ID No. B75873927, and registered
                                office at Pasaje de Bisbal 6, 1st Floor, 28028, Madrid.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                This Privacy Policy governs access to and use of the website (hereinafter, the{' '}
                                <strong>“Website”</strong>) that <strong>TREKZY</strong> makes available to Internet users (hereinafter, the{' '}
                                <strong>“Users”</strong>) interested in the content (hereinafter, the <strong>“Content”</strong>) and services
                                (hereinafter, the <strong>“Services”</strong>) offered by <strong>TREKZY</strong> therein.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Contact email address:{' '}
                                <Link href="mailto:datospersonales@trekzy.com">datospersonales@trekzy.com</Link>
                            </Typography>
                        </Section>

                        <Section title="2.- Recommendations">
                            <Typography variant="body1" paragraph>
                                Please read carefully and follow these recommendations:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Keep your device equipped with properly updated antivirus software to protect against malware and
                                    spyware applications that may jeopardize your Internet browsing and the information stored on your
                                    device.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Read and review this Privacy Policy and all legal texts made available by <strong>TREKZY</strong> on
                                    the <strong>Website</strong>.
                                </ListItem>
                            </List>
                        </Section>

                        <Section title="3.- Information about the data collected by TREKZY through the Website">
                            <Typography variant="body1" paragraph>
                                For the proper functioning of the <strong>Website</strong>, <strong>TREKZY</strong> may have access to the
                                following data provided, where applicable, by the <strong>User</strong>:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>(i) Identification data: first name, last name.</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (ii) Personal data: date of birth, gender, IP address, device used.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>(iii) Contact details: email address, telephone number.</ListItem>
                            </List>
                        </Section>

                        <Section title="4.- Why is TREKZY entitled to process your data?">
                            <Typography variant="body1" paragraph>
                                The legal basis that entitles <strong>TREKZY</strong> to process Users’ data through this Platform is the
                                implementation, at the User’s request, of pre-contractual measures.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Notwithstanding the foregoing, the legal basis for sending commercial communications shall be the
                                consent given by the <strong>User</strong>.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Your personal data are stored securely and processed with the utmost care, in accordance with the
                                provisions of Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016
                                on the protection of natural persons with regard to the processing of personal data and on the free
                                movement of such data (the <strong>“General Data Protection Regulation”</strong> or <strong>“GDPR”</strong>).
                            </Typography>

                            <Typography variant="body1" paragraph>
                                This Privacy Policy governs access to and use of the service that <strong>TREKZY</strong> makes available
                                to the <strong>User</strong> interested in the services and content hosted on the <strong>Website</strong>.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                In this regard, the <strong>User</strong> may withdraw consent at any time by sending a message to the
                                following email address:{' '}
                                <Link href="mailto:datospersonales@trekzy.com">datospersonales@trekzy.com</Link>, without affecting
                                the lawfulness of processing based on consent prior to its withdrawal.
                            </Typography>
                        </Section>

                        <Section title="5.- What are the purposes of processing your personal data?">
                            <Typography variant="body1" paragraph>
                                The personal data collected by <strong>TREKZY</strong> may be used for the following purposes, depending
                                on the consent given in the relevant registration form:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>(i) To provide the services offered through the Website.</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (ii) To manage, process, and respond to requests, applications, incidents, or inquiries from the User.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (iii) Where the data subject has given consent, to receive commercial communications or information
                                    about TREKZY’s products and services by post, telephone, email, SMS/MMS, or other equivalent
                                    electronic means of communication.
                                </ListItem>
                            </List>
                        </Section>

                        <Section title="6.- Accuracy of the data provided by Users">
                            <Typography variant="body1" paragraph>
                                The User guarantees the accuracy of the personal data provided and undertakes to notify <strong>TREKZY</strong>{' '}
                                of any changes thereto. The User shall be liable, in any case, for the accuracy of the data provided,
                                and <strong>TREKZY</strong> reserves the right to exclude from the services any User who has provided false
                                data, without prejudice to any other actions available at law.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Users are advised to protect their data with the utmost diligence by using appropriate security tools.
                                <strong> TREKZY</strong> shall not be liable for any theft, unlawful alteration, or loss of data.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Any modification or update of the data must be communicated to <strong>TREKZY</strong> through the
                                communication channels provided in this Privacy Policy.
                            </Typography>
                        </Section>

                        <Section title="7.- Data retention">
                            <Typography variant="body1" paragraph>
                                The protection of Users’ privacy and personal data is very important to <strong>TREKZY</strong>. Therefore,
                                <strong> TREKZY</strong> makes every effort to prevent User data from being misused. Only authorized
                                personnel have access to User data.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Users’ personal data will be retained while they remain in <strong>TREKZY</strong>’s database for the
                                purposes for which they were provided, provided that the User has not revoked consent by requesting
                                deletion of their account or erasure of certain personal data from the Website.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Subsequently, where necessary, <strong>TREKZY</strong> will keep the information blocked for the legally
                                established periods.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> undertakes to comply with its obligation of secrecy and confidentiality of personal
                                data in accordance with applicable legislation.
                            </Typography>
                        </Section>

                        <Section title="8.- Users’ rights">
                            <Typography variant="body1" paragraph>
                                Users have the right to:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (i) <strong>Access</strong> their personal data;
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (ii) Request <strong>rectification</strong> of inaccurate data;
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (iii) Request <strong>erasure</strong> of their data;
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (iv) Request <strong>restriction of the processing</strong> of their data;
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (v) <strong>Object</strong> to the processing of their data;
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (vi) Request <strong>data portability</strong>.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (vii) Users also have the right <strong>not to be subject to decisions based solely on automated processing of data</strong>.
                                </ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                The User may exercise all these rights by sending an email to{' '}
                                <Link href="mailto:datospersonales@trekzy.com">datospersonales@trekzy.com</Link>, stating the reason
                                for the request.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                The User may also send the request by ordinary mail to: Pasaje de Bisbal 6, 1st Floor, 28028, Madrid.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Any communication addressed to <strong>TREKZY</strong> must include the following information:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>User’s first and last name;</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>The specific request being made.</ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                Without prejudice to any other administrative remedy or judicial action, the User shall have the right
                                to lodge a complaint with a Supervisory Authority, in particular in the Member State of their habitual
                                residence, place of work, or place of the alleged infringement, if they consider that the processing of
                                their personal data does not comply with the applicable regulations or if they are not satisfied with the
                                exercise of their rights. The Supervisory Authority with which the complaint has been lodged shall inform
                                the complainant of the progress and outcome of the complaint.
                            </Typography>
                        </Section>

                        <Section title="9.- Data security">
                            <Typography variant="body1" paragraph>
                                The protection of Users’ privacy and personal data is very important to <strong>TREKZY</strong>. Accordingly,
                                <strong> TREKZY</strong> has taken all measures within its power to prevent misuse of such data, allowing
                                access only to authorized personnel.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> maintains adequate security measures for the protection of personal data in
                                accordance with applicable legislation and has implemented all technical means at its disposal to prevent
                                loss, misuse, alteration, unauthorized access, and theft of the data provided by the User through the
                                Website, without prejudice to informing the User that Internet security measures are not impregnable.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> undertakes to comply with the duty of secrecy and confidentiality regarding personal
                                data in accordance with applicable legislation.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> shall not be liable for any damages that may arise from the User’s breach of this
                                obligation.
                            </Typography>
                        </Section>

                        <Section title="10.- Transfers and/or disclosures to third parties">
                            <Typography variant="body1" paragraph>
                                Users are informed that their personal data may not be disclosed to third-party companies or national
                                entities. Users’ data may only be used by <strong>TREKZY</strong> for any purpose necessary to properly fulfill
                                the purposes of personal data processing set out in section 5 of this Privacy Policy.
                            </Typography>
                        </Section>

                        <Section title="11.- Questions">
                            <Typography variant="body1" paragraph>
                                If you have any questions about our Privacy Policy, please contact us by sending an email to{' '}
                                <Link href="mailto:datospersonales@trekzy.com">datospersonales@trekzy.com</Link>.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Likewise, if you consider that your rights have not been adequately safeguarded, you have the right to
                                lodge a complaint with the Spanish Data Protection Agency (Agencia Española de Protección de Datos),
                                whose contact details are: telephone numbers 900 293 183; postal address C/Jorge Juan 6, 28001 Madrid;
                                electronic office{' '}
                                <Link href="https://sedeagpd.gob.es/sede-electronica-web/" target="_blank" rel="noopener">
                                    https://sedeagpd.gob.es/sede-electronica-web/
                                </Link>
                                ; and application{' '}
                                <Link href="https://www.aepd.es" target="_blank" rel="noopener">
                                    www.aepd.es
                                </Link>
                                .
                            </Typography>
                        </Section>

                        <Section title="12.- Acceptance and Consent">
                            <Typography variant="body1" paragraph>
                                The User declares that they have been informed of the conditions regarding the protection of personal
                                data and accepts and consents to the processing thereof by <strong>TREKZY</strong>, in the manner and for the
                                purposes indicated in this Privacy Policy.
                            </Typography>
                        </Section>

                        <Divider sx={{ my: 4 }} />

                        {/* =====================
              LEGAL NOTICE
             ===================== */}
                        <ListItemHeader textAlign="center" styles={{ padding: 0, fontWeight: 'bold', paddingTop: 5 }}>LEGAL NOTICE</ListItemHeader>

                        <Section title="1.- Right to information">
                            <Typography variant="body1" paragraph>
                                Please note that this website{' '}
                                <Link href="https://www.trekzy.com" target="_blank" rel="noopener">
                                    www.trekzy.com
                                </Link>{' '}
                                (hereinafter, the <strong>“Website”</strong>) is owned by Tours Privados, S.L. (hereinafter,{' '}
                                <strong>“TREKZY”</strong>), with Tax ID No. B75873927, and registered office at Pasaje de Bisbal 6, 1st Floor,
                                28028, Madrid, registered within the Commercial Registry of Madrid, Section 8, Entry 1, Sheet M 845479.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Access to and/or use of the Website confers the status of user.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                The user (hereinafter, the <strong>“User”</strong>) may contact <strong>TREKZY</strong> via the email address{' '}
                                <Link href="mailto:datospersonales@trekzy.com">datospersonales@trekzy.com</Link> or by telephone at
                                (+34) 917 578 557.
                            </Typography>
                        </Section>

                        <Section title="2.- Use of the Website">
                            <Typography variant="body1" paragraph>
                                The User assumes responsibility for use of the Website. The Website may provide access to a multitude
                                of texts, graphics, drawings, designs, photographs, multimedia content, and information (hereinafter,
                                the <strong>“Content”</strong>) belonging to <strong>TREKZY</strong> or third parties to which the User may have
                                access.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                The User must make appropriate use of the Content and services offered through the Website and, by way
                                of example but not limitation, must refrain from:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (i) Engaging in unlawful, illegal activities or activities contrary to good faith and public order.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (ii) Causing damage to the physical and logical systems of TREKZY’s Website, its suppliers, or third
                                    parties.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (iii) Introducing or disseminating computer viruses or any other physical or logical systems capable
                                    of causing the aforementioned damage.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (iv) Attempting to access, use, and/or manipulate TREKZY’s data, data of third-party collaborators,
                                    and other users.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (v) Reproducing or copying, distributing, making available to the public through any form of public
                                    communication, transforming, or modifying the Content, unless authorized by TREKZY.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (vi) Removing, concealing, or manipulating Content subject to intellectual or industrial property
                                    rights and other identifying data of such rights of TREKZY or third parties incorporated into the
                                    Content, as well as technical protection devices or any information mechanisms that may be embedded in
                                    the Content.
                                </ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> shall have the right to investigate and report any of the aforementioned conduct in
                                accordance with the law, as well as to cooperate with authorities in the investigation of such actions.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> may temporarily suspend, without prior notice, access to the Website for maintenance,
                                repair, updating, or improvement operations. Nevertheless, whenever circumstances allow, <strong>TREKZY</strong>{' '}
                                will inform the User sufficiently in advance of the scheduled date for service suspension. <strong>TREKZY</strong>{' '}
                                shall not be responsible for the use that Users may make of the Content included on the Website.
                            </Typography>
                        </Section>

                        <Section title="3.- Intellectual and Industrial Property">
                            <Typography variant="body1" paragraph>
                                All intellectual property rights in the content and graphic design of this Platform (including, by way of
                                example, images, sound, audio, video, software, or texts; trademarks or logos; colour combinations;
                                structure and design; selection of materials used; computer programs necessary for its operation, access,
                                and use; etc.) are the exclusive property of <strong>TREKZY</strong> or a third party that has authorized their
                                use. Accordingly, <strong>TREKZY</strong> holds the exclusive right to exploit such content and graphic design.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Pursuant to Royal Legislative Decree 1/1996 of 12 April approving the consolidated text of the
                                Intellectual Property Law, and Law 17/2001 of 7 December on Trademarks, as well as any other supplementary
                                legislation on intellectual and industrial property, the reproduction, transmission, adaptation,
                                translation, distribution, or public communication, including making available or any other form of
                                commercial exploitation and/or modification of all or part of the Website content is prohibited, except
                                with the prior and express authorization of <strong>TREKZY</strong>.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> grants no license or authorization to use any of its intellectual or industrial
                                property rights or any other property or right related to the Website and/or its services or content.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                The User undertakes to respect <strong>TREKZY</strong>’s intellectual and industrial property rights. Temporary
                                reproduction and storage of Website content is permitted insofar as strictly necessary for the use and
                                viewing of the Website from a computer, tablet, or personal phone.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                The legitimacy of intellectual or industrial property rights over content provided by Users is the sole
                                responsibility of the Users, who shall be liable for any third-party claims arising from the unlawful use
                                of Website content.
                            </Typography>
                        </Section>

                        <Section title="4.- Data protection">
                            <Typography variant="body1" paragraph>
                                Use of this Platform may require Users to provide personal data. <strong>TREKZY</strong> processes such
                                information in accordance with applicable legislation and collects it in its Privacy Policy.
                            </Typography>
                        </Section>

                        <Section title="5.- Liability and warranties">
                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> declares that it has adopted all necessary measures, within its means and considering
                                the current state of technology, to ensure proper functioning and the absence of viruses and harmful
                                components on its Platform.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                However, <strong>TREKZY</strong> shall not be liable for:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (i) The accuracy, completeness, or timeliness of data provided by Users;
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (ii) Interruptions in Website operation or computer failures, telephone breakdowns, disconnections,
                                    delays, or blockages caused by deficiencies or overloads in telephone lines, data centres, the Internet
                                    system, or other electronic systems occurring during operation;
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (iii) Any damage caused by third parties who breach or violate TREKZY’s security systems.
                                </ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> shall not be responsible for the use that Users may make of the Content included on
                                the Website.
                            </Typography>
                        </Section>

                        <Section title="6.- Duration and modification">
                            <Typography variant="body1" paragraph>
                                This Legal Notice shall remain in force indefinitely, and <strong>TREKZY</strong> may make changes to the
                                conditions set forth herein, which shall take effect upon publication.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> may remove, add, or modify both the Content and the services provided, as well as the
                                manner in which they are located or presented. The conditions in force are those published at the time
                                the User accesses <strong>TREKZY</strong>’s Website.
                            </Typography>
                        </Section>

                        <Section title="7.- Hyperlinks">
                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> informs the User that, to its knowledge, the hyperlinks included on the Website are
                                not harmful and their content is correct. However, insofar as control over such hyperlinks does not
                                depend on <strong>TREKZY</strong>, it cannot assume any responsibility for the consequences of accessing links
                                to other applications or websites.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> is not responsible for the information contained in such third-party links or for any
                                effects arising therefrom. The inclusion of links to other websites or applications does not imply
                                approval of their content by <strong>TREKZY</strong> or the existence of any association between <strong>TREKZY</strong> and
                                their owners.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Accordingly, the User accesses such content at their own risk and under the terms of use governing it.
                            </Typography>
                        </Section>

                        <Section title="8.- Safeguard and interpretation">
                            <Typography variant="body1" paragraph>
                                This Legal Notice constitutes an agreement between each User and <strong>TREKZY</strong>.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                If the competent authority declares any provision unlawful, invalid, or unenforceable, such declaration
                                regarding one or more clauses shall not affect the validity of the remaining clauses.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong>’s failure to require strict compliance with any provision of this Legal Notice shall
                                not constitute nor be construed as a waiver of its right to require strict compliance in the future.
                            </Typography>
                        </Section>

                        <Section title="9.- General information">
                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> will pursue any breach of this Legal Notice, as well as any improper use of its portal,
                                by exercising all civil and criminal actions available under law.
                            </Typography>
                        </Section>

                        <Section title="10.- Notices">
                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> may send communications via the email address provided by Users in registration forms
                                or by any other means provided in the User’s contact details.
                            </Typography>
                        </Section>

                        <Divider sx={{ my: 4 }} />

                        {/* =====================
              COOKIE POLICY
             ===================== */}
                        <ListItemHeader textAlign="center" styles={{ padding: 0, fontWeight: 'bold', paddingTop: 5 }}>COOKIE POLICY</ListItemHeader>

                        <Typography variant="body1" paragraph>
                            TOURS PRIVADOS, S.L. (hereinafter, <strong>“TREKZY”</strong>) informs, through this Cookie Policy, about the use
                            of data storage and retrieval devices on Users’ terminal equipment.
                        </Typography>

                        <Section title="1.- What are cookies?">
                            <Typography variant="body1" paragraph>
                                This Platform uses cookies and/or similar technologies that store and retrieve information when you
                                browse. Generally, these technologies may serve a wide variety of purposes, such as recognizing you as a
                                user, obtaining information about your browsing habits, or personalizing the way content is displayed.
                                The specific uses of these technologies are described in the section “What does TREKZY use cookies for?”.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                The information collected by cookies is anonymous and does not contain sensitive information, as it does
                                not collect data that can personally identify the User. In any case, the User may access their browser
                                settings to modify and/or block the installation of cookies sent from the Website, without preventing
                                access to content as described in the sections “How to disable cookies?” and “Cookies on mobile devices”
                                of this Cookie Policy.
                            </Typography>
                        </Section>

                        <Section title="2.- What does TREKZY use cookies for?">
                            <Typography variant="body1" paragraph>
                                In accordance with Article 22 of the Law on Information Society Services and Electronic Commerce and
                                Recital (30) of the General Data Protection Regulation (GDPR), this Platform uses cookies or other data
                                storage and retrieval devices to track Users’ interactions with the services offered on the Website.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Cookies make it possible to recognize a User’s browser and the type of device from which the Website is
                                accessed, and are used to facilitate the User’s next visit and make the Website more useful.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                <strong>TREKZY</strong> uses cookies to:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>(i) Optimize User navigation by tracking the session.</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    (ii) Collect information to optimize navigation and improve the Website.
                                </ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                The Website uses the following types of cookies:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    <strong>Mandatory or technical cookies:</strong> strictly necessary to provide a service or content
                                    requested by the user. They handle technical aspects such as identifying sessions and managing tool
                                    preferences regarding use, interaction, and location of access to content.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    <strong>Preference or personalization cookies:</strong> allow information to be remembered so that the
                                    user accesses the service with certain characteristics that may differentiate their experience from
                                    that of another user, such as language or page configuration depending on the browser used.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    <strong>Statistical/analytical cookies:</strong> processed by us or by third parties, allowing us to
                                    quantify the number of users and thus perform measurement and statistical analysis of users’ use of the
                                    service offered. For this purpose, their browsing on the Website is analyzed to improve the products or
                                    services offered.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    <strong>Advertising cookies:</strong> processed by us or by third parties, allowing analysis of your
                                    Internet browsing habits so that we can display advertising related to your browsing profile.
                                </ListItem>
                            </List>
                        </Section>

                        <Section title="3.- How to disable cookies?">
                            <Typography variant="body1" paragraph>
                                Cookies that are not mandatory for navigation on this Platform may be disabled.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                These settings are available in the Website footer. In addition, all browsers allow changes to disable
                                cookie settings.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                For this reason, most browsers offer the possibility of managing cookies to obtain more precise control
                                over privacy. These settings are located in the “options” or “preferences” menu of your browser.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Below are links for each browser to disable cookies following the instructions provided:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    <strong>Internet Explorer</strong> ({' '}
                                    <Link href="https://goo.gl/iU2wh2" target="_blank" rel="noopener">
                                        https://goo.gl/iU2wh2
                                    </Link>
                                    )
                                    <List sx={{ listStyle: 'circle', pl: 4, mt: 1 }}>
                                        <ListItem sx={{ display: 'list-item' }}>From the Tools menu, select “Internet Options”.</ListItem>
                                        <ListItem sx={{ display: 'list-item' }}>Click on the “Privacy” tab.</ListItem>
                                        <ListItem sx={{ display: 'list-item' }}>
                                            You may delete cookies by selecting “Delete browsing history” and then, under “Cookies and site
                                            permissions”, accessing “See all cookies and site data” and selecting “Remove all”.
                                        </ListItem>
                                        <ListItem sx={{ display: 'list-item' }}>
                                            The “Cookies and site permissions” section also allows you to configure the privacy options
                                            preferred by the user.
                                        </ListItem>
                                    </List>
                                </ListItem>

                                <ListItem sx={{ display: 'list-item' }}>
                                    <strong>Mozilla Firefox</strong> ({' '}
                                    <Link href="http://goo.gl/QXWYmv" target="_blank" rel="noopener">
                                        http://goo.gl/QXWYmv
                                    </Link>
                                    )
                                    <List sx={{ listStyle: 'circle', pl: 4, mt: 1 }}>
                                        <ListItem sx={{ display: 'list-item' }}>
                                            At the top of the Firefox window, click on the Settings menu.
                                        </ListItem>
                                        <ListItem sx={{ display: 'list-item' }}>Select “Privacy &amp; Security”.</ListItem>
                                        <ListItem sx={{ display: 'list-item' }}>
                                            By choosing the “Custom” option, you may select which cookies you wish to block, along with other
                                            privacy-related settings.
                                        </ListItem>
                                    </List>
                                </ListItem>

                                <ListItem sx={{ display: 'list-item' }}>
                                    <strong>Google Chrome</strong> ({' '}
                                    <Link href="http://goo.gl/fQnkSB" target="_blank" rel="noopener">
                                        http://goo.gl/fQnkSB
                                    </Link>
                                    )
                                    <List sx={{ listStyle: 'circle', pl: 4, mt: 1 }}>
                                        <ListItem sx={{ display: 'list-item' }}>Click on the menu located on the toolbar.</ListItem>
                                        <ListItem sx={{ display: 'list-item' }}>Select “Settings”.</ListItem>
                                        <ListItem sx={{ display: 'list-item' }}>
                                            Under “Privacy and Security”, click on “Cookies and other site data”.
                                        </ListItem>
                                        <ListItem sx={{ display: 'list-item' }}>
                                            You may configure general cookie settings, as well as other privacy-related options.
                                        </ListItem>
                                    </List>
                                </ListItem>

                                <ListItem sx={{ display: 'list-item' }}>
                                    <strong>Safari</strong> ({' '}
                                    <Link href="https://goo.gl/dQywEo" target="_blank" rel="noopener">
                                        https://goo.gl/dQywEo
                                    </Link>
                                    )
                                    <List sx={{ listStyle: 'circle', pl: 4, mt: 1 }}>
                                        <ListItem sx={{ display: 'list-item' }}>
                                            In the Safari application on Mac, select “Preferences”.
                                        </ListItem>
                                        <ListItem sx={{ display: 'list-item' }}>Open the “Privacy” tab.</ListItem>
                                        <ListItem sx={{ display: 'list-item' }}>
                                            Choose the desired option under the “Block cookies” section.
                                        </ListItem>
                                        <ListItem sx={{ display: 'list-item' }}>
                                            Please note that certain features and full functionality of the Website may not be available after
                                            disabling cookies.
                                        </ListItem>
                                    </List>
                                </ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                If you do not wish to be tracked by cookies, Google has developed a browser add-on available at:{' '}
                                <Link href="http://goo.gl/up4ND" target="_blank" rel="noopener">
                                    http://goo.gl/up4ND
                                </Link>
                                .
                            </Typography>
                        </Section>

                        <Section title="4.- Cookies on mobile devices">
                            <Typography variant="body1" paragraph>
                                TREKZY’s Website also uses cookies or other storage devices on mobile devices. Cookies that are not
                                mandatory for navigation on this Platform may be disabled.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                These settings are available in the Website footer. In addition, as with desktop browsers, mobile
                                browsers allow changes to privacy settings to disable or delete cookies.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                If you wish to modify privacy options, follow the instructions provided by your mobile browser
                                developer. Examples include:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    iOS:{' '}
                                    <Link href="http://goo.gl/61xevS" target="_blank" rel="noopener">
                                        http://goo.gl/61xevS
                                    </Link>
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Windows Phone:{' '}
                                    <Link href="https://goo.gl/tKyb0y" target="_blank" rel="noopener">
                                        https://goo.gl/tKyb0y
                                    </Link>
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Chrome Mobile:{' '}
                                    <Link href="http://goo.gl/XJp7N" target="_blank" rel="noopener">
                                        http://goo.gl/XJp7N
                                    </Link>
                                </ListItem>
                            </List>
                        </Section>

                        <Section title="5.- Acceptance of cookies">
                            <Typography variant="body1" paragraph>
                                This Platform does not install its cookies on users’ devices until users have accepted their
                                installation.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Please note that if you do not accept the installation of cookies or disable any of them in your
                                settings, certain services may not be available without their use, or you may not be able to access
                                certain services or fully benefit from everything this Platform offers.
                            </Typography>
                        </Section>

                        <Divider sx={{ my: 4 }} />

                        {/* Footer */}
                        <Typography variant="body2" color="text.secondary">
                            <Link href="https://www.trekzy.com" target="_blank" rel="noopener">
                                www.trekzy.com
                            </Link>
                        </Typography>
                    </Box>
                </StaticPagesWrapper>
            </MainLayout>
        );
    }
}

export default PrivacyPolicies
